import { Link } from 'react-router-dom';

function FooterCtrl() {
  return (
    <div className="container">
      <small>
      Copyright (c) 2002-2025 Watts Research, all rights reserved. | <Link to={`/policies`}>Policies</Link>
      </small>
    </div>
  );
}

export default FooterCtrl;
